import { DataManagementHeader } from "./components/DataManagementHeader";
import { DataManagementContent } from "./components/DataManagementContent";
import { JSX } from "react";

const DataManagementPageContainer = (): JSX.Element => {
    return (
        <div className={"p-data-management"}>
            <DataManagementHeader />
            <DataManagementContent />
        </div>
    );
};

export default DataManagementPageContainer;
